import { FlowNodeType, FlowNodeTypeValue } from './types';

export interface NodeInfo {
  label: string;
  color: string;
  category: 'trigger' | 'action' | 'branching' | 'terminal' | 'legacy';
}

export const NODE_METADATA: Record<FlowNodeTypeValue, NodeInfo> = {
  [FlowNodeType.TriggerNewConversation]: { label: 'Nova conversa',     color: '#0ea5e9', category: 'trigger' },
  [FlowNodeType.TriggerKeyword]:         { label: 'Palavra-chave',     color: '#0284c7', category: 'trigger' },
  [FlowNodeType.SendMessage]:            { label: 'Enviar mensagem',   color: '#3b82f6', category: 'action' },
  [FlowNodeType.AskQuestion]:            { label: 'Fazer pergunta',    color: '#8b5cf6', category: 'action' },
  [FlowNodeType.Menu]:                   { label: 'Menu',              color: '#f59e0b', category: 'branching' },
  [FlowNodeType.Condition]:              { label: 'Condição',          color: '#ef4444', category: 'branching' },
  [FlowNodeType.AiAgent]:                { label: 'Agente IA',         color: '#22c55e', category: 'action' },
  [FlowNodeType.TransferToQueue]:        { label: 'Transferir p/ fila',    color: '#f97316', category: 'action' },
  [FlowNodeType.TransferToAgent]:        { label: 'Transferir p/ agente',  color: '#fb923c', category: 'action' },
  [FlowNodeType.SetTag]:                 { label: 'Definir etiqueta',  color: '#6366f1', category: 'action' },
  [FlowNodeType.SetCategory]:            { label: 'Definir categoria', color: '#ec4899', category: 'action' },
  [FlowNodeType.Webhook]:                { label: 'Webhook',           color: '#14b8a6', category: 'action' },
  [FlowNodeType.Wait]:                   { label: 'Aguardar',          color: '#6b7280', category: 'action' },
  [FlowNodeType.WaitForReply]:           { label: 'Aguardar resposta', color: '#64748b', category: 'action' },
  [FlowNodeType.ResolveTicket]:          { label: 'Encerrar atendimento', color: '#15803d', category: 'terminal' },
  [FlowNodeType.End]:                    { label: 'Fim',               color: '#374151', category: 'terminal' },
  [FlowNodeType.TriggerEmailReceived]:   { label: 'E-mail recebido',   color: '#0369a1', category: 'trigger' },
  [FlowNodeType.Start]:                  { label: 'Início (legacy)',   color: '#9ca3af', category: 'legacy' },
};

export function getNodeInfo(type: FlowNodeTypeValue): NodeInfo {
  return NODE_METADATA[type] ?? { label: String(type), color: '#6b7280', category: 'action' };
}

export const CATEGORY_LABELS: Record<NodeInfo['category'], string> = {
  trigger: 'Gatilhos',
  action: 'Mensagens / Ações',
  branching: 'Lógica',
  terminal: 'Finalização',
  legacy: 'Legacy',
};

// Ordem explícita de exibição no palette (independente do valor inteiro do enum).
// Mude esse array — não os enum values — pra reordenar visualmente.
const TYPES_BY_CATEGORY: Record<NodeInfo['category'], FlowNodeTypeValue[]> = {
  trigger: [
    FlowNodeType.TriggerNewConversation,
    FlowNodeType.TriggerKeyword,
  ],
  action: [
    FlowNodeType.SendMessage,
    FlowNodeType.AskQuestion,
    FlowNodeType.AiAgent,
    FlowNodeType.TransferToQueue,
    FlowNodeType.TransferToAgent,
    FlowNodeType.SetTag,
    FlowNodeType.SetCategory,
    FlowNodeType.Webhook,
    FlowNodeType.Wait,
    FlowNodeType.WaitForReply,
  ],
  branching: [
    FlowNodeType.Menu,
    FlowNodeType.Condition,
  ],
  terminal: [
    FlowNodeType.ResolveTicket,
    FlowNodeType.End,
  ],
  legacy: [
    FlowNodeType.Start,
  ],
};

export function getTypesByCategory(category: NodeInfo['category']): FlowNodeTypeValue[] {
  return TYPES_BY_CATEGORY[category] ?? [];
}
